import { RouteConfig, protectedRouteList } from '../../routes/routesConfig';

type NavMenuItem = RouteConfig & { subMenu?: any[] };

export const menuItems: NavMenuItem[] = [
  {
    ...protectedRouteList.swapBaskets,
  },
  {
    ...protectedRouteList.orderEntry,
  },
  {
    ...protectedRouteList.dashboard,
  },
];
